(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.fg-hd');
      this.type = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.last = 0;
      this.always = this.type === 'always' || this.type === 'reduce-logo-size';
      if (this.type === 'none' || !this.bar) return;
      if (this.always) this.bar.classList.add('fg-pinned');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
    onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var h = this.offsetHeight;
      if (this.always) {
        this.last = y;
        return;
      }
      if (y > h) {
        this.bar.classList.add('fg-pinned');
        if (y > this.last + 4) this.bar.classList.add('fg-hidden');
        else if (y < this.last - 4) this.bar.classList.remove('fg-hidden');
      } else {
        this.bar.classList.remove('fg-pinned', 'fg-hidden');
      }
      this.last = y;
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.fg-hd');
      this.type = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.last = 0;
      this.always = this.type === 'always' || this.type === 'reduce-logo-size';
      if (this.type === 'none' || !this.bar) return;
      if (this.always) this.bar.classList.add('fg-pinned');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
    onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var h = this.offsetHeight;
      if (this.always) {
        this.last = y;
        return;
      }
      if (y > h) {
        this.bar.classList.add('fg-pinned');
        if (y > this.last + 4) this.bar.classList.add('fg-hidden');
        else if (y < this.last - 4) this.bar.classList.remove('fg-hidden');
      } else {
        this.bar.classList.remove('fg-pinned', 'fg-hidden');
      }
      this.last = y;
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
